﻿export class JsTreeConfig {
  constructor(private options: IJsTreeOptions) { }

  public toJson(): Object {
    return {
      'core': {
        'data': this.options.nodes,
        'animation': false,
        'themes': {
          'dots': false,
          'icons': false
        }
      },
      'checkbox': {
        'keep_selected_style': false
      },
      'plugins': [ 'checkbox' ]
    }
  }
}

export interface IJsTreeOptions {
  nodes: any;
}
